import { IAugmentedJQuery, IController, IPromise, IScope } from 'angular';

export class Modal {
  constructor( public controller: IController,
               public scope: IScope,
               public $element: IAugmentedJQuery,
               public close: IPromise<any>,
               public closed: IPromise<any> ) {
  }
}



// WEBPACK FOOTER //
// ./app/components/modals/gmc-modal/shared/modal.ts